const tabs = Array.from(document.querySelectorAll('.js-authorization__tabs'));

tabs.forEach((tab) => {
	const tabTitles = Array.from(tab.querySelectorAll('.js-authorization__tabs-title'));
	const tabContents = Array.from(tab.querySelectorAll('.js-authorization__tabs-content'));

	tabTitles.forEach((tabTitle, index) => {
		tabTitle.addEventListener('click', () => {
			const tabTitleActive = tab.querySelector('.js-authorization__tabs-title.active');
			const tabContentActive = tab.querySelector('.js-authorization__tabs-content.active');

			tabTitleActive.classList.remove('active');
			tabContentActive.classList.remove('active');

			tabTitles[index].classList.add('active');
			tabContents[index].classList.add('active');
		});
	});
});
